// Utilitaires pour le formatage et l'arrondi des nombres

/**
 * Arrondit un prix à un nombre de décimales approprié selon la valeur
 * @param price Le prix à arrondir
 * @returns Le prix arrondi en string avec le bon nombre de décimales
 */
export const formatPrice = (price: number): string => {
  if (price === 0) return '0';
  
  // Pour des prix très petits (< 0.01), on garde plus de décimales
  if (price < 0.01) {
    return price.toFixed(8); // 8 décimales pour les petits prix
  }
  
  // Pour des prix moyens (0.01 à 100), on garde 4 décimales
  if (price < 100) {
    return price.toFixed(4);
  }
  
  // Pour des prix élevés (>= 100), on garde 2 décimales
  return price.toFixed(2);
};

/**
 * Formate un nombre avec le nombre approprié de décimales
 * @param value Le nombre à formater
 * @param maxDecimals Nombre maximum de décimales (par défaut 8)
 * @returns Le nombre formaté en string
 */
export const formatNumber = (value: number, maxDecimals: number = 8): string => {
  if (value === 0) return '0';
  
  // Supprimer les zéros inutiles à la fin
  const formatted = value.toFixed(maxDecimals);
  return formatted.replace(/\.?0+$/, '');
};

/**
 * Arrondit un prix de cryptomonnaie en gardant une précision appropriée
 * @param price Le prix à arrondir
 * @returns Le prix arrondi
 */
export const roundCryptoPrice = (price: number): number => {
  if (price === 0) return 0;

  // Pour des prix très petits, garder 8 décimales significatives
  if (price < 0.01) {
    return Math.round(price * 100000000) / 100000000;
  }

  // Pour des prix moyens, garder 4 décimales
  if (price < 100) {
    return Math.round(price * 10000) / 10000;
  }

  // Pour des prix élevés, garder 2 décimales
  return Math.round(price * 100) / 100;
};

/**
 * Arrondit une quantité de cryptomonnaie à 8 décimales
 * Résout les problèmes de précision des nombres flottants en JavaScript
 * @param amount Le montant à arrondir
 * @returns Le montant arrondi
 */
export const roundAmount = (amount: number): number => {
  if (amount === 0) return 0;
  // Arrondir à 8 décimales pour éviter les imprécisions des nombres flottants
  return Math.round(amount * 100000000) / 100000000;
};